import { render, staticRenderFns } from "./sideSelect.vue?vue&type=template&id=45bffcac&lang=html"
import script from "./sideSelect.vue?vue&type=script&lang=js"
export * from "./sideSelect.vue?vue&type=script&lang=js"
import style0 from "./sideSelect.vue?vue&type=style&index=0&id=45bffcac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports